import { render, staticRenderFns } from "./RecommendationCard.vue?vue&type=template&id=5ddee072&scoped=true"
import script from "./RecommendationCard.vue?vue&type=script&lang=js"
export * from "./RecommendationCard.vue?vue&type=script&lang=js"
import style0 from "./RecommendationCard.vue?vue&type=style&index=0&id=5ddee072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddee072",
  null
  
)

export default component.exports